<template>
    <div class="addvideo">
        <div class="addvideo_top">
            <i class="el-icon-edit"></i>
            <div>添加文章</div>
        </div>
        <div class="information_box">
            <div class="catalogue">基本信息</div>
            <div class="must">为必填项</div>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="文章标题" prop="name">
                <el-input style="width:300px" v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="查看权限"  prop="resource">
                <el-radio-group v-model="ruleForm.resource">
                    
                    <el-radio :label="item.id" v-for="(item,index) of membertype" :key="index">{{item.name}}</el-radio>
                    <!-- <el-radio :label="2">月费会员以上可看</el-radio>
                    <el-radio :label="3">终身会员可看</el-radio> -->
                </el-radio-group>
            </el-form-item>
            <el-form-item label="模块类型"  prop="moduleId">
                <el-radio-group v-model="ruleForm.moduleId">
                    <el-radio :label="item.id" v-for="(item,index) of documenttype" :key="index">{{item.name}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="新闻正文"  prop="src" >
                <el-upload
                    v-model="ruleForm.src"
                    v-loading="uploadloading"
                    element-loading-text="拼命上传中"
                    class="avatar-uploader"
                    action="#"
                    :show-file-list="false"
                    :http-request="newsvideoupload"
                    accept=".mp4"
                    >
                    <video class="video_box" v-if="ruleForm.src!=''">
                        <source  :src="basevideo+ruleForm.src">
                    </video>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload> 
            </el-form-item>
            <el-form-item>
                <el-button v-if="isedit==false" :disabled="submitloading" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                <el-button v-if="isedit!=false" :disabled="submitloading" type="primary" @click="editForm('ruleForm')">提交</el-button>
                <el-button @click="remove()">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import baseurl from '../../utils/index'
import basevideo from '../../utils/video'
import axios from 'axios'
export default{
    data(){
        var validatePass = (rule, value, callback) => {
            if (value==='') {
                callback(new Error('请选择视频'));
            }
        };
        return{
            baseurl,
            basevideo,
            uploadloading:false,
            submitloading:false,
            ruleForm: {
                name:'',
                resource:'',
                moduleId:'',
                src:'',
            },
            rules: {
                name: [
                    { required: true, message: '请输入文章标题', trigger: 'blur' },
                    { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
                ],
                resource: [{ required: true, message: '请选择查看权限', trigger: 'change' }],
                moduleId: [{ required: true, message: '请选择模块类型', trigger: 'change' }],
                src: [{  required: true, message: '请上传视频',  trigger:['change','blur'] }]
            },
            documenttype:null,
            user:null,
            content:null,
            isedit:false,
            membertype:null,
        }
    },
    created(){
        this.user=JSON.parse( sessionStorage.getItem('user'))
        this.content=JSON.parse( sessionStorage.getItem('scoped'))
        this.MemberTypefn()
        this.$set(this.ruleForm,'moduleId',Number( this.$route.query.selectactive))

        if(this.$route.query.isedit!=undefined){
            this.isedit=Boolean( this.$route.query.isedit)
            console.log(111,this.content);
           
            this.$http.get(`/article?id=${this.content.id}`).then((res)=>{
                if(res.code==200){
                     this.ruleForm.name=res.data.title;
                    this.$set(this.ruleForm,'moduleId',Number( this.$route.query.selectactive))

                    this.$set(this.ruleForm,'resource',res.data.auth)
                    this.ruleForm.src=res.data.content
                }
                console.log(111,res);
            })
        }
        this.module()
        
    },
    methods:{
        module(){
            this.$http.get('/module').then((res)=>{
                    if(res.code==200){
                        console.log(111,res);
                        for (let i = 0; i <Object.keys( res.data).length; i++) {
                           if(res.data[i].name=='冲绳观光'){
                                res.data.splice(i,1)
                           }
                        }
                        this.documenttype=res.data
                    }
                })
            },
        MemberTypefn(){
            this.$http.get(`/auth/memberType`).then((res)=>{
                if(res.code==200){
                    for(let i=0;i<res.data.length;i++){
                        if(res.data[i].id==1){
                            res.data[i].name='全部可看'
                        }
                    }
                    this.membertype=res.data
                    // console.log(11515,res);
                }
            })
        },
        //取消
        remove(){
            this.$router.push({
                path:'/allModule',
                query:{selectactive: this.$route.query.selectactive}
            })
        },
        //上传成功 去除验证
        uploadSuccess(response, file, fileList) {
                this.$refs.ruleForm.clearValidate('src') // 手动触发fileList校验规则
        },
        //上传视频
        newsvideoupload(file){  
            console.log(1515,file.file.size/1024/1024);
            if(file.file.size/1024/1024<1024){
                this.$set(this.ruleForm,'src','')
                // console.log(11111,file);
                this.uploadloading=true;
                this.submitloading=true;
                    let filedate=new FormData()
                        filedate.append("file",file.file)
                        axios.post(`${baseurl}file/upload?folder=video`, filedate,
                            {
                                headers:{
                                    'Content-Type':'multipart/form-data',
                                
                                    'token':sessionStorage.getItem('user_token')
                                },
                            }
                        ).then((res)=>{
                    
                        // console.log(111151515,res.data);
                        if(res.data.code==200){
                        
                            this.$nextTick(()=>{

                                this.$set(this.ruleForm,'src',res.data.data)
                            })
                            this.uploadloading=false;
                            this.submitloading=false;
                            // console.log(111111);
                            this.uploadSuccess()
                        }else{
                            this.$message({
                                message:res.data.message,
                                type:'error'
                            })
                        }
                    })
            }else{
                this.$message({
                    message:'视频大小小于1G',
                    type:'error'
                })
            }
           
        },
        //编辑确定添加文章
        editForm(formName) {
            
            this.$refs[formName].validate((valid) => {
            if (valid) {
                let obj={
                    "auth": this.ruleForm.resource,
                    "content": this.ruleForm.src,
                    "contentType": 2,
                    "id": this.content.id,
                    "moduleId":this.ruleForm.moduleId,
                    "publisherId": this.user.id,
                    "publisherName":this.user.name,
                    "title": this.ruleForm.name
                }
                console.log(123,obj);
                this.$http.put('/article',obj).then((res)=>{
                    if(res.code==200){
                        this.$message({
                            message:'编辑添加成功',
                            type:'success'
                        })
                        this.$router.push({
                            path:'/allModule',
                            query:{selectactive: this.$route.query.selectactive}
                        })
                    }
                })
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        //确定添加文章
        submitForm(formName) {
            
            this.$refs[formName].validate((valid) => {
            if (valid) {
                let obj={
                    "auth": this.ruleForm.resource,
                    "content": this.ruleForm.src,
                    "contentType": 2,
                    "moduleId":this.ruleForm.moduleId,
                    "publisherId": this.user.id,
                    "publisherName":this.user.name,
                    "title": this.ruleForm.name
                }
                console.log(123,obj);
                this.$http.post('/article',obj).then((res)=>{
                    if(res.code==200){
                        this.$message({
                            message:'添加成功',
                            type:'success'
                        })
                        this.$router.push({
                            path:'/allModule',
                            query:{selectactive: this.$route.query.selectactive}
                        })
                    }
                })
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
    }
}
</script>
<style lang="less" scoped>
    .avatar-uploader{
        width: 180px;
        height: 180px;
        border: 1px dashed #d9d9d9;
        display: block;
        .video_box{
            width: 180px;
            height: 180px;
        }
    }
   .avatar-uploader /deep/.el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader /deep/.el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #d9d9d9;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
        // border: 1px dashed red;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .addvideo{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        background: #fff;
        padding: 10px 30px;
        .addvideo_top{
            display: flex;
            align-items: center;
        }
        .information_box{
            box-sizing: border-box;
            display: flex;
            align-items: center;
            margin: 0px 30px;
            height: 40px;
            margin-top: 10px;
            .catalogue{
                font-weight: bold;
                margin-right: 20px;
                position: relative;
                
            }
            .catalogue::before{
                position: absolute;
                content: "";
                display: inline-block;
                width: 6px;
                height: 30px;
                background-color: #014790;
                top: -3px;
                left: -15px;
                border-radius: 5px;
                
            }
            .must{
                color:#666666 ;
                font-size: 13px;
            }
            .must::before{
                content: "*";
                color: red;
                margin-right: 5px;
            }
        }
        
    }
</style>